import React from "react";
import { Modal } from "react-bootstrap";
import CloseButton from "react-bootstrap/CloseButton";
import CommonButton from "../../commonButton";
import "./style.scss";

const DeleteTaskModal = ({ show, onHide, onDelete }) => {
  return (
    <Modal
      show={show}
      centered
      onHide={onHide}
      className="delete-modal"
    >
      <Modal.Header className="delete-modal-header">
        <div className="form-modal">
          <Modal.Title>Remove Element?</Modal.Title>
        </div>
        <CloseButton onClick={onHide} className="close-cta-wrapper" />
      </Modal.Header>
      <Modal.Body>
        <div className="delete-confirmation-form">
          <p>Are you sure you want to delete this element? This action cannot be undone.</p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <CommonButton
          onClick={onHide}
          variant="secondary"
          btnText="NO, CANCEL"
        />
        <CommonButton
          onClick={onDelete}
          variant="danger"
          btnText="YES, DELETE"
        />
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteTaskModal;
